import {  useParams } from "react-router-dom";
// import { useEffect, useState } from "react";
import ProviderForm, { ProviderType } from "./ProviderForm";
// import { GetApiMethod } from "../../Utils/ApiService";
import { AuthorizedLayout } from "../Layouts/AuthorizedLayout";

const ProviderFormWrapper = () => {
  const { id } = useParams();
  // const location = useLocation();

  // const queryParams = new URLSearchParams(location.search);


  // const [, setProvider] = useState<ProviderType | null>(null);

  // useEffect(() => {
  //   if (id) {
  //     const fetchProvider = async () => {
  //       const response = await GetApiMethod(`/provider/${id}`);
  //       setProvider(response?.data);
  //     };
  //     fetchProvider();
  //   }
  // }, [id]);

  return( <AuthorizedLayout><ProviderForm /></AuthorizedLayout> )
};

export default ProviderFormWrapper;
